import { defineComponent as _defineComponent } from 'vue'
import AppInputSelect from './AppInputSelect.vue';
  import { LANGUAGES } from '@/config/constants';
  import { ref, watch } from 'vue';
  import { useStateStore } from '../stores/StateStore';
  import { UseUserActions } from '../composables/useUserActions';
  import { useTemplateConfgigStore } from '../stores/templateConfStore';
  import { loadLocaleMessages } from '../plugins/i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props, { expose: __expose }) {
  __expose();

  const userActions = UseUserActions();
  const stateStore = useStateStore();
  const templateConfig = useTemplateConfgigStore();
  const selection = ref(LANGUAGES.find(item => item.value.toLowerCase() === stateStore.lang));
  watch(selection, () => {
    const newLang = selection.value.value.toLowerCase();
    stateStore.setLang(newLang);
    userActions.updateLanguage(newLang);
    loadLocaleMessages(newLang);
  });

const __returned__ = { userActions, stateStore, templateConfig, selection, AppInputSelect, get LANGUAGES() { return LANGUAGES }, ref, watch, get useStateStore() { return useStateStore }, get UseUserActions() { return UseUserActions }, get useTemplateConfgigStore() { return useTemplateConfgigStore }, get loadLocaleMessages() { return loadLocaleMessages } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})